"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleTimelineCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DetailsLine_1 = require("./DetailsLine");
var SimpleTimelineCard = function (_a) {
    var heading = _a.heading, headingButton = _a.headingButton, _b = _a.details, details = _b === void 0 ? [] : _b;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "spaceBetween" },
            react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5" }, heading),
            headingButton),
        details.length > 0 && (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" }, details.map(function (m, index) { return (react_1.default.createElement(DetailsLine_1.DetailsLine, { key: index, title: m.title, value: m.value })); })))));
};
exports.SimpleTimelineCard = SimpleTimelineCard;
